module.exports = __webpack_public_path__ + "img/error-access.60d95b64.png";